"use strict"

__webpack_public_path__ = window.ic_loader_data.context.__public_path__ // eslint-disable-line no-undef

if (process.env.NODE_ENV === "production") {
  require("./vendor")
}

require("../sass/-main.scss")

let $ = require("jquery")

$(document).ready(function() {
  // todo create createModule

  /** hover state for sidebar images to show buttons **/
  $( '.img-wrap' ).mouseenter( function() {
    $(this).find('.overlay').fadeIn('fast')
    $(this).find('.img-action-links').fadeIn('fast')
  }).mouseleave( function() {
    $(this).find('.overlay').fadeOut('fast')
    $(this).find('.img-action-links').fadeOut('fast')
  })

  /** initialize popups for images **/
  $('.view-large').magnificPopup({
    type: 'image',
    titleSrc: 'title',
    // other options
  })

  $('.play-video').magnificPopup({
    type: 'inline',
    midClick: true
  })


  $('.js-press-release').on('click', function(e) {
    e.preventDefault()

    $('.at-svc-printfriendly')[0].click()
  })


  $.ajax({
    url: "https://api.curator.io/v1.1/feeds/c06e04f4-8d81-4b49-a908-520f5e9a/posts?limit=20&rnd=1515532036638&after=eyJwaW5uZWQiOjAsInNvdXJjZV9jcmVhdGVkX2F0IjoiMjAxOC0wMS0wOCAxODozNDoyMyJ",
    context: document.body
  }).done(function(data) {
    if (data) {
      let hashPostCount = data.postCount;
      let chatter_number = $('.chatter__number')
      chatter_number.html(hashPostCount)
      chatter_number.parent().removeClass('d-none')
    }
  })

}) // end document ready

$(window).load(function() {
  if($('.home-slide').length > 0) {
    $('.home-slide').flexslider({
      animation: 'slide'
    });
  }

  if($('.gallery-slides').length > 0) {
    $('.gallery-slides').each(function() {
      $(this).flexslider({
        animation: 'slide',
        animationLoop: false,
        itemWidth: 265,
        itemMargin: 30,
        minItems: 0,
        maxItems: 4
      });
      $(this).find('.gallery-item').magnificPopup({
        type: 'image',
        gallery:{
          enabled: true
        }
      });
    });
  }
});



// WEBPACK FOOTER //
// ./assets/js/index.js